import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from '@rci/common';
import { AlertContent, AlertContentEntity, AlertContentFacadeService } from '@rogers/self-serve-common/alert-content';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AlertContentService {
  private readonly alertContentFacadeService = inject(AlertContentFacadeService);
  private readonly translate = inject(TranslateService);

  getAlertContent$(pageName: string): Observable<AlertContent> {
    return this.fetchAlertContent$(pageName).pipe(
      map(alertContentEntity => {
        if (!alertContentEntity) {
          return { alerts: [] };
        }

        return {
          alerts: alertContentEntity.alerts,
        };
      }),
    );
  }

  private fetchAlertContent$(pageName: string): Observable<AlertContentEntity> {
    return this.translate.stream('lang').pipe(
      filter(lang => [Languages.EN, Languages.FR].includes(lang)),
      switchMap(lang => {
        return this.alertContentFacadeService.getAlertContents$(pageName, lang);
      }),
    );
  }
}
